import React from 'react';
import {
  HomeGroupLayout,
  MemberSeatsSelectTable
} from 'components';

/**
 * 設定座號
 */

export const MemberSeatsSelectPage = () => {
  return (
    <HomeGroupLayout>
      <MemberSeatsSelectTable />
    </HomeGroupLayout>
  );
};

MemberSeatsSelectPage.propTypes = {

};


